import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

import { formatDate } from "../../../Components/Common/FormatDate";
import SalesReportService from "../../../Services/QRCodeServices/ReportServices/SalesReportService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import ReturnBill from "../component/ReturnBill";
import { exportToExcel } from "../../../utils/exportToExcel";
import SalesReportDetail from "../component/SalesReportDetail";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const ReportSales = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  console.log("🚀 ~ ReportSales ~ selectedItem:", selectedItem);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);

  const [responseData, setResponseData] = useState();
  const toggleDetailModal = (row) => {
    setIsDetailOpen(!isDetailOpen);
    setSelectedItem(row);
  };
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Invoice No",
      selector: (row) => `${row.invoiceNumber}`,
      cell: (row) => row.invoiceNumber,
      sortable: true,
    },
    {
      name: "Order Ref Id",
      selector: (row) => row.orderReferenceId,
      sortable: true,
      wrap: true,
    },
    {
      name: "Bill Date",
      selector: (row) => formatDate(row.billDate),
      sortable: true,
    },

    {
      name: "Discount (%)",
      selector: (row) => row.discountPercentage,
      sortable: true,
      right: true,
    },
    {
      name: "Total",
      selector: (row) => row.grandTotal,
      sortable: true,
      right: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-success"
            className="btn-sm"
            onClick={() => toggleDetailModal(row)}
          >
            <i className="bx bx-show" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row)}
          >
            Return
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await SalesReportService.getList();

      setData(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCustomers();
  }, []);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = data.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.invoiceNumber || ""} ${
      pkg?.orderReferenceId || ""
    }`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDeleteModal();
  };


  const handleExportExcel = () => {
    const columnMapping = {
      "S.N": (row, index) => index + 1,
      "Invoice No.": "invoiceNumber",
      "Order Reference Id": "orderReferenceId",
      "Bill Date": (row) => formatDate(row.billDate),
      "Discount (%)": "discountPercentage",
      "Total Amount": "grandTotal",
    };

    exportToExcel(filteredData, columnMapping, "SalesReports.xlsx");
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Sales Report List" pageTitle="Sales Report" />
      </div>
      <Row>
        <Col md={8} xs={12} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by invoice no & order referenceId"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col md={4}>
          <div>
            <button className="btn btn-success" onClick={handleExportExcel}>
              Export Excel
            </button>{" "}
          </div>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData}
          />
        </CardBody>
      </Card>
      {/* <CustomerForm
        modal={addModal}
        toggleModal={() => {
          setAddModal(false);
          setSelectedItem(null); // Clear editing state when closing
        }}
        setData={setData}
        data={data}
        selectedItem={selectedItem}
        fetchCustomers={fetchCustomers}
      /> */}
      <ReturnBill
        show={deleteModal}
        // onDeleteClick={handleReturn}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedItem} // Pass the selected item
        setSelectedItem={setSelectedItem}
      />

      <SalesReportDetail
        isOpen={isDetailOpen}
        toggle={toggleDetailModal}
        selectedItem={selectedItem}
      />
    </div>
  );
};

export default ReportSales;
